var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.214 8.098L12 13.938l7.786-5.84c.137.271.214.578.214.902v8a2 2 0 01-2 2H6a2 2 0 01-2-2V9c0-.324.077-.63.214-.902z",
    fill: "#C2B6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38 7.098C5.576 7.034 5.784 7 6 7h12c.216 0 .424.034.62.098L12 12.063 5.38 7.098z",
    fill: "#C2B6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.53 12.47a.75.75 0 10-1.06 1.06l1.72 1.72H14a.75.75 0 000 1.5h5.19l-1.72 1.72a.75.75 0 101.06 1.06l3-3a.75.75 0 000-1.06l-3-3z",
    fill: "#6244FF"
  })));
}

export default SvgEmail;